// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { leaveUsFeedbackStyles } from "@conklin/App/Components/Product/LeaveFeedback";
import IconComment from "@conklin/XDL/Icons/IconComment";
import { createLinkIconStyles } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

leaveUsFeedbackStyles.buttonWrapper = {
    css: css`
        display: flex;
    `,
};

leaveUsFeedbackStyles.submitFeedbackButton = {
    css: css`
        margin-top: 12px;
        margin-left: auto;
    `,
};

leaveUsFeedbackStyles.leaveUsFeedback = createLinkIconStyles(IconComment, "small", "left", false, {
    css: css`
        gap: 5px;
    `,
});

leaveUsFeedbackStyles.errorNotify = {
    css: css`
        margin: 12px 0 0 0;
    `,
};
